export default __webpack_public_path__ + "static/media/eHealthMv_bg.c84d153e.jpg";